import type { Interaction, InteractionResponse } from '~/types/__generated__'

type CreateInteractionPayload = {
  type: Interaction.type
  targetType: 'professional' | 'company' | 'vacancy'
  targetId: number | string
  initiatorType?: 'professional' | 'company' | 'vacancy'
  initiatorId?: number | string
  reason?: string
}

export function useApiInteraction() {
  const client = useStrapiClient()

  async function createInteraction(data: CreateInteractionPayload) {
    const response = await client<InteractionResponse>(`/interactions`, {
      method: 'POST',
      body: { data },
    })
    return response?.data
  }

  async function deleteInteraction(id: number | string) {
    const response = await client<InteractionResponse>(`/interactions/${id}`, {
      method: 'DELETE',
    })
    return response?.data
  }

  return {
    createInteraction,
    deleteInteraction,
  }
}
